<template>
  <section class="comm-page dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="treeNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <div class="comm-page-head">
        <h2>{{ departmentName ? `${departmentName} · VOIP 通信组` : 'VOIP 通信组' }}</h2>
        <el-alert
          type="info"
          :closable="false"
          show-icon
          title="创建同步微信；组不可删除；每组最多 50 台；仅自研设备可入组。" />
      </div>

      <div v-if="departmentId > 0" class="toolbar-filter-bar">
        <el-form :inline="true" class="toolbar-filter-form">
          <div class="toolbar-filter-fields">
            <el-form-item label="组名">
              <el-input v-model="filters.groupName" placeholder="组名" clearable class="toolbar-field-w-md" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="loadList">查询</el-button>
            </el-form-item>
          </div>
          <div class="toolbar-filter-actions">
            <el-button type="success" icon="el-icon-plus" @click="openCreate">新建通信组</el-button>
          </div>
        </el-form>
      </div>

      <div v-if="departmentId > 0" class="comm-panel">
        <div class="tbl-scroll-host">
          <el-table
            :data="list"
            v-loading="loading"
            class="comm-table"
            empty-text="暂无数据"
            size="small"
            height="100%"
            style="width: 100%">
            <el-table-column prop="GroupName" label="组名" min-width="140" show-overflow-tooltip />
            <el-table-column prop="WxGroupId" label="微信组ID" min-width="160" show-overflow-tooltip />
            <el-table-column label="设备数" width="100" align="center">
              <template slot-scope="scope">
                {{ scope.row.DeviceCount != null ? scope.row.DeviceCount : scope.row.deviceCount }}/{{ scope.row.MaxDeviceCount || scope.row.maxDeviceCount || 50 }}
              </template>
            </el-table-column>
            <el-table-column label="订阅家长" width="100" align="center">
              <template slot-scope="scope">
                <el-button type="text" @click="openAuthList(scope.row)">{{ authCount(scope.row) }}</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="CreateTime" label="创建时间" min-width="150" show-overflow-tooltip />
            <el-table-column label="操作" width="200" align="center">
              <template slot-scope="scope">
                <div class="table-op-pair">
                  <el-button type="text" class="table-op-link" @click="openDevices(scope.row)">管理设备</el-button>
                  <el-button type="text" class="table-op-link" @click="openAuthList(scope.row)">订阅家长</el-button>
                  <el-button type="text" class="table-op-link" @click="openEdit(scope.row)">编辑</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="comm-pager">
          <el-pagination
            layout="total, prev, pager, next, jumper"
            :page-size="pageSize"
            :total="total"
            :current-page.sync="page"
            @current-change="loadList" />
        </div>
      </div>

      <div v-else class="comm-empty-tip">请选择学校后管理 VOIP 通信组</div>

      <el-dialog :title="form.id ? '编辑通信组' : '新建通信组'" :visible.sync="formVisible" width="480px" :close-on-click-modal="false">
        <el-form :model="form" label-width="90px">
          <el-form-item label="组名" required>
            <el-input v-model="form.groupName" :disabled="!!form.id" maxlength="32" placeholder="同步微信，创建后不可改" />
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.description" type="textarea" />
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" :loading="saving" @click="submitForm">保存</el-button>
        </div>
      </el-dialog>

      <el-dialog
        :title="deviceDialogTitle"
        :visible.sync="deviceVisible"
        width="760px"
        custom-class="voip-device-dialog"
        :close-on-click-modal="false"
        append-to-body
      >
        <div class="voip-device-body">
          <div class="toolbar-filter-bar toolbar-filter-bar--embed">
            <el-form :inline="true" class="toolbar-filter-form" @submit.native.prevent="applyDeviceSearch">
              <div class="toolbar-filter-fields">
                <el-form-item>
                  <el-input
                    v-model="deviceKeyword"
                    clearable
                    placeholder="SN / 名称"
                    class="toolbar-field-w-lg"
                    @keyup.enter.native="applyDeviceSearch"
                  />
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" size="small" icon="el-icon-search" @click="applyDeviceSearch">查询</el-button>
                </el-form-item>
              </div>
              <div class="toolbar-filter-actions">
                <el-button type="success" size="small" icon="el-icon-plus" @click="loadCandidates">添加设备</el-button>
                <el-button type="info" size="small" icon="el-icon-remove-outline" :disabled="!selectedInGroup.length" @click="unbindSelected">移出选中</el-button>
                <el-button type="warning" size="small" icon="el-icon-upload2" :disabled="!selectedInGroup.length" @click="registerSelected">手动注册</el-button>
              </div>
            </el-form>
          </div>
          <el-table
            ref="deviceTable"
            :data="detailDevices"
            v-loading="detailLoading"
            border
            size="small"
            max-height="380"
            empty-text="暂无数据"
            :row-key="deviceRowKey"
            @selection-change="onInGroupSel"
          >
            <el-table-column type="selection" width="45" reserve-selection />
            <el-table-column prop="DeviceSn" label="SN" min-width="120" show-overflow-tooltip />
            <el-table-column prop="TerminalName" label="名称" min-width="120" show-overflow-tooltip />
            <el-table-column label="微信注册" width="90" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.WxDeviceRegistered || scope.row.wxDeviceRegistered ? 'success' : 'info'">
                  {{ scope.row.WxDeviceRegistered || scope.row.wxDeviceRegistered ? '已注册' : '未注册' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="JoinTime" label="入组时间" width="160" />
          </el-table>
          <div class="voip-device-pager">
            <el-pagination
              layout="total, prev, pager, next"
              :page-size="devicePageSize"
              :total="deviceTotal"
              :current-page.sync="devicePage"
              @current-change="loadDevicePage"
            />
          </div>
        </div>
        <div slot="footer">
          <el-button @click="deviceVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="选择候选自研设备" :visible.sync="candidateVisible" width="640px" :close-on-click-modal="false" append-to-body>
        <el-table :data="candidates" v-loading="candidateLoading" border @selection-change="onCandidateSel" size="small" max-height="360">
          <el-table-column type="selection" width="45" />
          <el-table-column prop="KqTerminalId" label="SN" min-width="120" />
          <el-table-column prop="TerminalName" label="名称" min-width="120" />
          <el-table-column label="微信注册" width="90" align="center">
            <template slot-scope="scope">
              {{ scope.row.WxDeviceRegistered || scope.row.wxDeviceRegistered ? '已注册' : '未注册' }}
            </template>
          </el-table-column>
        </el-table>
        <div slot="footer">
          <el-button @click="candidateVisible = false">取消</el-button>
          <el-button type="primary" :loading="binding" :disabled="!selectedCandidates.length" @click="bindSelected">确认加入</el-button>
        </div>
      </el-dialog>

      <voip-group-auth-dialog
        :visible.sync="authVisible"
        :voip-group-id="authGroupId"
        :group-name="authGroupName"
      />
    </section>
  </section>
</template>

<script>
import './styles/comm-page.css'
import DepartmentPane from '../../components/DepartmentPane'
import VoipGroupAuthDialog from './components/VoipGroupAuthDialog.vue'
import {
  getCommVoipGroupList,
  createCommVoipGroup,
  updateCommVoipGroup,
  getCommVoipGroupDeviceList,
  getCommVoipCandidateDevices,
  bindCommVoipDevices,
  unbindCommVoipDevices,
  registerCommVoipDevices
} from '../../api/modules/misc'

export default {
  name: 'VoipGroup',
  components: { DepartmentPane, VoipGroupAuthDialog },
  data() {
    return {
      departmentId: 0,
      departmentName: '',
      loading: false,
      list: [],
      total: 0,
      page: 1,
      pageSize: 10,
      filters: { groupName: '' },
      formVisible: false,
      saving: false,
      form: { id: 0, groupName: '', description: '' },
      deviceVisible: false,
      currentGroup: null,
      detailLoading: false,
      detailDevices: [],
      deviceTotal: 0,
      deviceKeyword: '',
      deviceKeywordApplied: '',
      devicePage: 1,
      devicePageSize: 10,
      selectedInGroup: [],
      candidateVisible: false,
      candidateLoading: false,
      candidates: [],
      selectedCandidates: [],
      binding: false,
      authVisible: false,
      authGroupId: 0,
      authGroupName: ''
    }
  },
  computed: {
    deviceDialogTitle() {
      const name = this.currentGroup
        ? (this.currentGroup.GroupName || this.currentGroup.groupName || '')
        : ''
      return name ? `管理设备 - ${name}` : '管理设备'
    }
  },
  methods: {
    treeNodeClick(data) {
      this.departmentId = data && data.value ? data.value : 0
      this.departmentName = data && data.label ? data.label : ''
      this.page = 1
      this.loadList()
    },
    async loadList() {
      if (!this.departmentId) return
      this.loading = true
      try {
        const res = await getCommVoipGroupList({
          departmentId: this.departmentId,
          groupName: this.filters.groupName || undefined,
          page: this.page,
          pageSize: this.pageSize
        })
        if (res.data.success) {
          const page = res.data.response || {}
          this.list = page.data || []
          this.total = page.dataCount || 0
        } else {
          this.$message.error(res.data.msg || '加载失败')
        }
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      if (!this.departmentId) {
        this.$message.warning('请先选择学校')
        return
      }
      this.form = { id: 0, groupName: '', description: '' }
      this.formVisible = true
    },
    openEdit(row) {
      this.form = {
        id: row.Id != null ? row.Id : row.id,
        groupName: row.GroupName || row.groupName || '',
        description: row.Description || row.description || ''
      }
      this.formVisible = true
    },
    authCount(row) {
      const n = row && (row.AuthCount != null ? row.AuthCount : row.authCount)
      return Number(n) || 0
    },
    /** 查看该通信组已订阅家长。最后更新：2026-08-27 */
    openAuthList(row) {
      this.authGroupId = row.Id != null ? row.Id : row.id
      this.authGroupName = row.GroupName || row.groupName || ''
      this.authVisible = true
    },
    async submitForm() {
      if (!this.form.id && !this.form.groupName) {
        this.$message.warning('请填写组名')
        return
      }
      this.saving = true
      try {
        let res
        if (!this.form.id) {
          res = await createCommVoipGroup({
            departmentId: this.departmentId,
            groupName: this.form.groupName,
            description: this.form.description
          })
        } else {
          res = await updateCommVoipGroup({
            id: this.form.id,
            description: this.form.description
          })
        }
        if (res.data.success) {
          this.$message.success(res.data.msg || '保存成功')
          this.formVisible = false
          this.loadList()
        } else {
          this.$message.error(res.data.msg || '保存失败')
        }
      } finally {
        this.saving = false
      }
    },
    /** 设备表格行主键，跨页勾选保留。最后更新：2026-08-27 */
    deviceRowKey(row) {
      return String(row.KqtDeviceTerminalId || row.kqtDeviceTerminalId || row.DeviceSn || row.deviceSn || '')
    },
    /** 清空管理设备弹窗中的勾选。最后更新：2026-08-27 */
    clearDeviceSelection() {
      this.selectedInGroup = []
      this.$nextTick(() => {
        if (this.$refs.deviceTable) this.$refs.deviceTable.clearSelection()
      })
    },
    async openDevices(row) {
      this.currentGroup = row
      this.deviceKeyword = ''
      this.deviceKeywordApplied = ''
      this.devicePage = 1
      this.deviceVisible = true
      this.clearDeviceSelection()
      await this.loadDevicePage()
    },
    applyDeviceSearch() {
      this.devicePage = 1
      this.deviceKeywordApplied = this.deviceKeyword
      this.loadDevicePage()
    },
    /** 分页加载组内设备。最后更新：2026-08-27 */
    async loadDevicePage() {
      if (!this.currentGroup) return
      const id = this.currentGroup.Id != null ? this.currentGroup.Id : this.currentGroup.id
      this.detailLoading = true
      try {
        const res = await getCommVoipGroupDeviceList({
          voipGroupId: id,
          keyword: (this.deviceKeywordApplied || '').trim() || undefined,
          page: this.devicePage,
          pageSize: this.devicePageSize
        })
        if (res.data.success) {
          const page = res.data.response || {}
          this.detailDevices = page.data || []
          this.deviceTotal = page.dataCount || 0
          const maxPage = Math.max(1, Math.ceil(this.deviceTotal / this.devicePageSize) || 1)
          if (this.devicePage > maxPage) {
            this.devicePage = maxPage
            await this.loadDevicePage()
          }
        } else {
          this.$message.error(res.data.msg || '加载设备失败')
        }
      } finally {
        this.detailLoading = false
      }
    },
    onInGroupSel(rows) {
      this.selectedInGroup = rows || []
    },
    async loadCandidates() {
      this.candidateVisible = true
      this.candidateLoading = true
      this.selectedCandidates = []
      try {
        const gid = this.currentGroup.Id != null ? this.currentGroup.Id : this.currentGroup.id
        const res = await getCommVoipCandidateDevices({
          departmentId: this.departmentId,
          voipGroupId: gid
        })
        if (res.data.success) {
          this.candidates = res.data.response || []
        } else {
          this.$message.error(res.data.msg || '加载候选失败')
        }
      } finally {
        this.candidateLoading = false
      }
    },
    onCandidateSel(rows) {
      this.selectedCandidates = rows || []
    },
    async bindSelected() {
      const gid = this.currentGroup.Id != null ? this.currentGroup.Id : this.currentGroup.id
      const ids = this.selectedCandidates.map((x) => (x.Id != null ? x.Id : x.id))
      this.binding = true
      try {
        const res = await bindCommVoipDevices({ voipGroupId: gid, kqtDeviceTerminalIds: ids })
        if (res.data.success) {
          this.$message.success(res.data.msg || '绑定成功')
          this.candidateVisible = false
          await this.loadDevicePage()
          this.loadList()
        } else {
          this.$message.error(res.data.msg || '绑定失败')
        }
      } finally {
        this.binding = false
      }
    },
    async unbindSelected() {
      const gid = this.currentGroup.Id != null ? this.currentGroup.Id : this.currentGroup.id
      const ids = this.selectedInGroup.map((x) => (x.KqtDeviceTerminalId != null ? x.KqtDeviceTerminalId : x.kqtDeviceTerminalId))
      const res = await unbindCommVoipDevices({ voipGroupId: gid, kqtDeviceTerminalIds: ids })
      if (res.data.success) {
        this.$message.success(res.data.msg || '移出成功')
        this.clearDeviceSelection()
        await this.loadDevicePage()
        this.loadList()
      } else {
        this.$message.error(res.data.msg || '移出失败')
      }
    },
    async registerSelected() {
      const ids = this.selectedInGroup.map((x) => (x.KqtDeviceTerminalId != null ? x.KqtDeviceTerminalId : x.kqtDeviceTerminalId))
      const res = await registerCommVoipDevices({
        departmentId: this.departmentId,
        kqtDeviceTerminalIds: ids
      })
      if (res.data.success) {
        this.$message.success(res.data.msg || '注册成功')
        await this.loadDevicePage()
      } else {
        this.$message.error(res.data.msg || '注册失败')
      }
    }
  }
}
</script>

<style scoped>
.comm-page-head .el-alert { margin-bottom: 0; }
.voip-device-pager {
  display: flex;
  justify-content: flex-end;
}
</style>
<style>
.voip-device-dialog .el-dialog__body {
  padding: 20px 20px 24px;
}
.voip-device-dialog .voip-device-body {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.voip-device-dialog .el-table {
  width: 100%;
}
.voip-device-dialog .el-table__empty-block {
  min-height: 320px;
}
</style>
